import React, { useRef } from "react";
import { Body, Container, EntryAnimation, Heading } from "../../atoms";
import { LabeledCallToAction, MediaBlock } from "../../molecules";
export default function TextVideo(param) {
    var title = param.title, description = param.description, className = param.className, image = param.image, label = param.label, action = param.action, video = param.video, actionLabel = param.actionLabel;
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: TextVideo.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-flow-row grid-cols-1 gap-6 auto-rows-max md:gap-11 md:grid-cols-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-flow-row grid-cols-1 gap-6 auto-rows-max md:gap-8"
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h1",
        variant: "h1"
    }, title)), /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        delay: 0.1
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: "md",
        className: "prose"
    }, description)), !!(label && action) && /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        delay: 0.2
    }, /*#__PURE__*/ React.createElement(LabeledCallToAction, {
        label: actionLabel,
        action: action
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "order-first md:order-last"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(MediaBlock, {
        image: image,
        video: video,
        label: label
    })))));
}

//# sourceMappingURL=TextVideo.js.map